import Flex from "components/common/flex"
import { IconText } from "components/custom"
import { t } from "i18next"

export const createFormLabels = ({ fieldName, helpText }) => {
  return (
    <Flex gap="6px" align="start" vertical>
      <div>{t(fieldName)}</div>
      <IconText
        icon="BsInfo"
        title={t(helpText)}
        iconProps={{
          style: { color: "#707070" },
          hasBackground: true,
          size: "1.2em",
          iconContainerStyle: { padding: 0, "--icon-bg-color": "#E6E6E6" },
        }}
        style={{ "--typography-color": "#9D9D9D", fontSize: 12, gap: 8 }}
      />
    </Flex>
  )
}
